export default "__VITE_ASSET__DsmtU1VC__"